import megerParams from './megerParam';
import axios from './httpInstances';
import IO from '@/config/api-config';
import { setUrlQuery } from '@/common/utils';

let request = function({ path = '', _interface, params }, options = {}) {
  let rqParams = megerParams({ _interface, params });
  const date = Date.now();
  const url = setUrlQuery({ url: path, query: { _t: date } });
  return axios.post(url, rqParams, options);
};

export default {
  fetch({ path = IO.defaultPath, _interface, params }, options) {
    return request({ path, _interface, params }, options);
  }
};
